import(/* webpackMode: "eager" */ "/app/src/assets/scss/main.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SiteLayout"] */ "/app/src/features/site/ui/layouts/site-layout.jsx");
